import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import DocumentCreationButton from '../../../../components/DocumentCreationButton';
import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';
import { statementStyle } from '../Components/Statement';

const MuscleImaging = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  const showProcedureCodeHeader = documents.some(d => d.procedureCode && d.procedureCode.length > 0);
  const showStatementHeader = documents.some(d => d.statement && d.statement.length > 0);

  const showProcedureCode = (d: IMRI) => d.procedureCode && d.procedureCode.length > 0;
  const showStatement = (d: IMRI) => d.statement && d.statement.length > 0;
  return (
    <HistorySection
      headerText={<FormattedMessage id={'imaging.muscleImaging'} />}
      newButton={
        <DocumentCreationButton
          name="muscleImaging"
          text={'imaging.newMuscleImaging'}
          onClick={startEdit({} as IMuscleImaging, 'muscleImaging')}
          width={15}
          height={3}
          fontSize={12}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            {showProcedureCodeHeader && (
              <Item xs={2}>
                <FormattedMessage id="imaging.procedureCode" />
              </Item>
            )}
            {showStatementHeader && (
              <Item xs={3}>
                <FormattedMessage id="imaging.statementText" />
              </Item>
            )}
          </>
        }
        contentFormat={(d: IMuscleImaging): React.JSX.Element => (
          <>
            {showProcedureCodeHeader && <Item xs={2}>{showProcedureCode(d) ? d.procedureCode : ''}</Item>}
            {showStatementHeader && (
              <Item xs={3} style={statementStyle}>
                {showStatement(d) ? d.statement : ''}
              </Item>
            )}
          </>
        )}
        makeDate
        makeControls
        historyRowControls={(d: IControlProps) => <HistoryRowControls document={d} startEdit={startEdit} />}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IMuscleImaging[];
  startEdit: (document: IMuscleImaging, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
}

export default MuscleImaging;
